let SIMULATION_LISTENER = "https://wp-online-api-ref-portal-dev.azurewebsites.net/api";
let ONLINE_API_SERVICE = "https://qa-api.westpay.se";
let ONLINE_API_PUBLIC_SWAGGER = "";
let ONLINE_API_SIMULATION_HUB = "https://wp-online-api-ref-portal-dev.azurewebsites.net/api/simulationHub"

let OCP_APIM = ""
let TOKEN = ""

export var COOKIE_DOMAIN = ".westpay.se";

switch (process.env.REACT_APP_SERVER_TYPE) {
    case "Production":
        SIMULATION_LISTENER = "https://simulator.westpay.se";
        ONLINE_API_SERVICE = "https://demo-api.westpay.se";
        ONLINE_API_PUBLIC_SWAGGER = "https://demo-api.westpay.se";
        ONLINE_API_SIMULATION_HUB = "https://simulator.westpay.se/simulationHub"
        OCP_APIM = "7e9a4614929c432fb3ab31749dcf41ef"
        TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IkNhc3BlY28iLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE3MTkzOTM3OTksImV4cCI6MjAzNDc1Mzc5OSwiaWF0IjoxNzE5MzkzNzk5LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiMTEzNzgifQ.hbgvJRtFNE4idvYpBSkRqNLNR8RtPj7tER5yFymzv90"
        break;
    case "Local":
    case "Development":
        SIMULATION_LISTENER = "https://simulator-dev.westpay.se";
        ONLINE_API_SERVICE = "https://dev-api.westpay.se";
        ONLINE_API_PUBLIC_SWAGGER = "https://dev-api.westpay.se";
        ONLINE_API_SIMULATION_HUB = "https://simulator-dev.westpay.se/simulationHub"
        OCP_APIM = "7e9a4614929c432fb3ab31749dcf41ef"
        TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IkNhc3BlY28iLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE3MTkzOTM3OTksImV4cCI6MjAzNDc1Mzc5OSwiaWF0IjoxNzE5MzkzNzk5LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiMTEzNzgifQ.hbgvJRtFNE4idvYpBSkRqNLNR8RtPj7tER5yFymzv90"
        break;
    case "QA":
        SIMULATION_LISTENER = "https://simulator-qa.westpay.se";
        ONLINE_API_SERVICE = "https://qa-api.westpay.se";
        ONLINE_API_PUBLIC_SWAGGER = "https://qa-api.westpay.se"
        ONLINE_API_SIMULATION_HUB = "https://simulator-qa.westpay.se/simulationHub"
        OCP_APIM = "592a7e2cacd9490baf78f2fa036e243e"
        TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6Ildlc3RwYXkgQUIiLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE2OTExNTI2NjAsImV4cCI6MjAwNjUxMjY2MCwiaWF0IjoxNjkxMTUyNjYwLCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiMTIzNDU2NzgifQ.2lRDix7e7KxCBkZiurPPVK5fHe5IxdcR-JV10lzdopw"
        break;
    default:
        SIMULATION_LISTENER = "https://simulator.westpay.se";
        ONLINE_API_SERVICE = "https://demo-api.westpay.se";
        ONLINE_API_PUBLIC_SWAGGER = "https://demo-api.westpay.se";
        ONLINE_API_SIMULATION_HUB = "https://simulator.westpay.se/simulationHub"
        OCP_APIM = "7e9a4614929c432fb3ab31749dcf41ef"
        TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IkNhc3BlY28iLCJyb2xlIjoiTWVyY2hhbnQiLCJuYmYiOjE3MTkzOTM3OTksImV4cCI6MjAzNDc1Mzc5OSwiaWF0IjoxNzE5MzkzNzk5LCJpc3MiOiJXZXN0cGF5IEFCIiwiYXVkIjoiMTEzNzgifQ.hbgvJRtFNE4idvYpBSkRqNLNR8RtPj7tER5yFymzv90"
        break;
}

export const SIMULATION_ENDPOINT = SIMULATION_LISTENER;
export const ONLINE_API_ENDPOINT = ONLINE_API_SERVICE;
export const PUBLIC_SWAGGER_URL = ONLINE_API_PUBLIC_SWAGGER;
export const SIMULATION_HUB = ONLINE_API_SIMULATION_HUB

//Error Codes
export const HTTP_STATUS_CODE_200_OK = 200;
export const HTTP_STATUS_CODE_201_CREATED = 201;
export const HTTP_STATUS_CODE_204_NO_CONTENT_SUCCESS = 204;
export const HTTP_STATUS_CODE_400_BAD_REQUEST = 400;
export const HTTP_STATUS_CODE_403_FORBIDDEN = 403;
export const HTTP_STATUS_CODE_401_UNAUTHORIZED = 401;
export const HTTP_STATUS_CODE_404_NOT_FOUND = 404;
export const HTTP_STATUS_CODE_409_CONFLICT = 409;
export const HTTP_STATUS_CODE_422_UNPROCESSABLE_ENTITY = 422;
export const HTTP_STATUS_CODE_429_TOOMANYREQ = 429;
export const HTTP_STATUS_CODE_415_UN_SUPPORTED_MEDIA_TYPE = 415;
export const HTTP_STATUS_CODE_500_INTERNAL_SERVER_ERROR = 500;
export const HTTP_STATUS_CODE_503_SERVICE_UNAVAILABLE = 503;
export const HTTP_STATUS_CODE_504_GATEWAY_TIMEOUT = 504;

export const ERROR_MESSAGE_401_UNAUTHORIZED = 'You have provided invalid credentials. Please try again';
export const ERROR_MESSAGE_403_FORBIDDEN = 'You are not authorized to perform this operation. Please contact the system administrator to request permission';


export const START_SIMULATION_ENDPOINT = '/web-sim/api/v1/startSimulation'
export const UPDATE_SIMULATION_ENDPOINT = '/web-sim/api/v1/updateSimulation'
export const STOP_SIMULATION_ENDPOINT = '/web-sim/api/v1/stopSimulation'

export const CREATE_PAYMENT_REQUEST = '/in-store/api/v1/purchase'
export const LINK_TERMINAL_REQUEST = '/in-store/api/v1/terminal/link'
export const UNLINK_TERMINAL_REQUEST = '/in-store/api/v1/terminal/unlink'

export const DEFAULT_TERMINAL = '80000780'

export const OCP_APIM_VALUE = OCP_APIM;
export const TOKEN_VALUE = TOKEN;